import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withTheme, Grid } from '@material-ui/core';
import { FHEContainerForm, FHEItemText, FHEMiniFormEditButton, FHEDivider, FHETextField } from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { updateProductModuleLabel } from '../../../../../../data/Products/actions';

class SDM19WTS extends PureComponent {
    static propTypes = {
        theme: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        label: PropTypes.string,
        fheCenter_mac: PropTypes.string,
        updateProductModuleLabel: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        lineType: PropTypes.string,
        type: PropTypes.string,
        code: PropTypes.string,
        alarmState: PropTypes.string,
        batteryLevel: PropTypes.string
    };

    static defaultProps = {
        fheCenter_mac: null,
        label: null,
        lineType: null,
        type: null,
        code: null,
        alarmState: null,
        batteryLevel: null
    };

    constructor(props) {
        super(props);
        this.state = {
            labelDisabled: true,
            textInput_error: {},
            sendLabelLoading: false,
            label: null
        };
    }

    static getDerivedStateFromProps(props, state) {
        const { labelDisabled, sendLabelLoading } = state;
        const { label } = props;
        if (labelDisabled && !sendLabelLoading && label !== state.label) {
            return {
                label
            };
        }

        return null;
    }

    handleEditLabel = () => {
        const { labelDisabled } = this.state;

        this.setState({
            labelDisabled: !labelDisabled
        });
    };

    handleFormError = (fields, message) => {
        let res = {};
        Object.keys(fields).map(field => {
            fields[field].forEach(error => {
                if (res[field] === undefined) res[field] = [];

                res[field].push(
                    <p key={error} className="mb-1">
                        {Translator.translate(`general.fields.error.${error}`)}
                    </p>
                );
            });
        });

        this.setState({
            textInput_error: res
        });

        return Toastr.error(message);
    };

    handleChangeLabelWithVerification = event => {
        const { textInput_error, label } = this.state;
        let targetValue = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

        const fieldLengthRules = {
            label: 255
        };

        let newTextInput_error = this.removeKey(textInput_error, event.target.name);

        let maxLength = fieldLengthRules[event.target.name];
        if (maxLength && targetValue.length > maxLength) targetValue = label;
        if (targetValue === '') targetValue = null;

        this.setState({
            [event.target.name]: targetValue,
            textInput_error: newTextInput_error
        });
    };

    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    };

    isEmpty = value => {
        return value === null || /^\s*$/.test(value);
    };

    loadInputs = () => {
        const { label } = this.props;
        this.setState({
            labelDisabled: true,
            textInput_error: {},
            sendLabelLoading: false,
            label
        });
    };

    removeKey = (myObj, deleteKey) => {
        return Object.assign(
            {},
            ...Object.entries(myObj)
                .filter(([k]) => k !== deleteKey)
                .map(([k, v]) => ({ [k]: v }))
        );
    };

    confirmEditLabel = () => {
        const { label } = this.state;
        const { updateProductModuleLabel, match, code, type, fheCenter_mac, history } = this.props;

        this.setState({
            sendLabelLoading: true,
            labelDisabled: true
        });

        return updateProductModuleLabel(fheCenter_mac, match.params.productIdentifier, match.params.productType, type, code, label)
            .then(() => {
                Toastr.success(Translator.translate(`generic.products.actions.editProductModuleSuccess`));
                this.loadInputs();
            })
            .catch(error => {
                this.setState({
                    sendLabelLoading: false,
                    labelDisabled: false
                });
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${error.message ? error.message : error}`, 'socket.error.defaultError'),
                    Translator.translate(`generic.products.actions.editProductModuleError`)
                );
                if (error.validation && error.validation.errors) {
                    return this.handleFormError(error.validation.errors, Translator.translate(`generic.products.actions.editProductModuleError`));
                }
            });
    };

    render() {
        const { theme, profile, history, lineType, type, alarmState, batteryLevel } = this.props;
        const { labelDisabled, textInput_error, sendLabelLoading, label } = this.state;
        const userRightUpdate =
            profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes(`productModules_${type}_${lineType}_update`);
        return (
            <FHEContainerForm>
                <Grid container spacing={3}>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEMiniFormEditButton
                            handleEdit={this.handleEditLabel}
                            confirmEdit={this.confirmEditLabel}
                            sendLoading={sendLabelLoading}
                            formDisabled={labelDisabled}
                            hasRightToEdit={userRightUpdate}
                        >
                            <FHETextField
                                disabled={labelDisabled}
                                id="label"
                                value={!label || label === null ? '' : label}
                                error={textInput_error.label}
                                label={Translator.translate('general.table.column.label')}
                                name="label"
                                onChange={this.handleChangeLabelWithVerification}
                            />
                        </FHEMiniFormEditButton>
                    </Grid>
                </Grid>
                <FHEDivider color={theme.palette.colors.grey100} />
                <Grid container spacing={3}>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.alarmState')}
                            itemContent={Translator.translate(`general.productModules.alarmState.${alarmState}`)}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.batteryLevel')}
                            itemContent={Translator.translateWithFallback(
                                `general.productModules.batteryLevel.${batteryLevel}`,
                                `general.productModules.batteryLevel.unknowed`
                            )}
                        />
                    </Grid>
                </Grid>
            </FHEContainerForm>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const productKey = props.productKey;
    const product = state.environments[history.environment].data.Products.getIn(['list', productKey], new Map());
    let productModule = state.environments[history.environment].data.Products.getIn(['list', productKey, 'productModules'], new Map());

    if (productModule.size > 0) {
        productModule = productModule.first();
    }

    let fheCenter_mac = null;
    state.environments[history.environment].data.Boxes.get('list').map((box, macAddress) => {
        if (box.get('homeId') === productModule.get('homeId')) fheCenter_mac = macAddress;
    });
    return {
        profile: state.data.user,
        type: product.get('type'),
        lineType: productModule.get('lineType'),
        label: productModule.get('label'),
        alarmState: productModule.get('alarmState'),
        batteryLevel: productModule.get('batteryLevel'),
        fheCenter_mac
    };
}

export default withRouter(
    renderEnvComponent(
        'scenes/Products/components/Product/Fhe/SDM19WTS/index',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(
                    tools.mergePropsToAction(ownProps.history.environment, {
                        updateProductModuleLabel
                    }),
                    dispatch
                )
        )(withTheme(SDM19WTS))
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/Product/Fhe/SDM19WTS/index.js